/**
 * Implements the account details modal.
 */

import Radio from "backbone.radio";
import GenericModal from "../generic/modal/base";
import AccountModel from "../../models/account";
import Form from "./form";

const channel = Radio.channel("global");

const DEFAULTS = {
  title: "Account Details",
};

class AccountDetails extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  // @Override
  initialize() {
    // Create a model instance
    this.model = new AccountModel();

    // call superclass
    if (super.initialize) super.initialize();
  }

  // @Override
  onBeforeRender() {
    // Fetch data and listen for promise resolution.
    const promise = this.model.fetch();
    promise.done(this._onLoad.bind(this));
    promise.fail(this._onLoadFailure.bind(this));

    // call superclass
    if (super.onBeforeRender) super.onBeforeRender();
  }

  _onLoad() {
    // remove /self part from urlRoot now that we have an ID
    this.model.urlRoot = this.model.urlRoot.replace(/\/self/gi, "");

    this._show();
  }

  _onLoadFailure() {
    // dismiss modal
    this._hide();

    // display error message
    channel.trigger("status:show", {
      type: "danger",
      message:
        "Your account details could not be retrieved. Please notify your administrator.",
    });
  }

  _show() {
    this.body.show(
      new Form({
        model: this.model,
      })
    );
  }
}

export { AccountDetails as default };
